@use '@design/design-tokens/typography/typography' as *;

.chipsContainer {
  padding: 16px 0 0;
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
  overflow: hidden;
  flex-grow: 1;
  width: 100%;
  border-bottom: 1px solid var(--border-default);

  &.secondary {
    padding: 16px 16px 0;
    gap: 16px;
  }
}

.styledButton {
  position: absolute;

  &.prev {
    background: linear-gradient(
      to left,
      rgba(var(--background-default-rgb), 50%) 0%,
      rgba(var(--background-default-rgb), 80%) 12.5%,
      rgba(var(--background-default-rgb), 100%) 50%
    );
    left: -3px;
  }

  &.next {
    background: linear-gradient(
      to right,
      rgba(var(--background-default-rgb), 50%) 0%,
      rgba(var(--background-default-rgb), 80%) 12.5%,
      rgba(var(--background-default-rgb), 100%) 50%
    );
    right: -3px;
  }
}

.tabButton {
  @include typography-v2-body-sm;
  color: var(--text-default);
  padding: 5px 11px;
  cursor: pointer;
  width: fit-content;
  white-space: nowrap;

  &.secondary {
    padding: 8px 15px;
  }

  &.active {
    color: var(--text-primary);
    border-bottom: 2px solid var(--border-primary);
  }
}
